var _extends2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

import React, { createElement } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import Element from './Element';
import set from './utils/set';
import traverse from './utils/traverse';
import Input from './Input';
import Select from './Select';
import Textarea from './Textarea';

function isEmpty(value) {
  return typeof value === 'undefined' || value === null || value === '';
}

var Fieldset = function (_Element) {
  _inherits(Fieldset, _Element);

  function Fieldset() {
    _classCallCheck(this, Fieldset);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, _Element.call.apply(_Element, [this].concat(args)));

    _this.registeredChildren = [];
    return _this;
  }

  Fieldset.prototype.getTotals = function getTotals() {
    var totals = [];
    if (typeof this.props.total !== 'undefined') {
      totals.push(this.props.total);
    }

    var parent = this.getParent();
    if (!parent) {
      return totals;
    }

    var parentTotals = parent.getTotals();
    return [].concat(totals, parentTotals);
  };

  Fieldset.prototype.getIndexes = function getIndexes() {
    var indexes = [];
    if (typeof this.props.index !== 'undefined') {
      indexes.push(this.props.index);
    }

    var parent = this.getParent();
    if (!parent) {
      return indexes;
    }

    var parentIndexes = parent.getIndexes();
    return [].concat(indexes, parentIndexes);
  };

  Fieldset.prototype.setValue = function setValue(value, component, notifyChildren) {
    _Element.prototype.setValue.call(this, value, component, notifyChildren);

    if (notifyChildren) {
      this.notifyChildren();
    }
  };

  Fieldset.prototype.originalValueChanged = function originalValueChanged() {
    _Element.prototype.originalValueChanged.call(this);
    this.notifyChildren();
  };

  Fieldset.prototype.notifyChildren = function notifyChildren() {
    var registeredChildren = this.registeredChildren;

    registeredChildren.forEach(function (child) {
      return child.originalValueChanged();
    });
  };

  Fieldset.prototype.registerChild = function registerChild(child, name) {
    if (name && name[0] === '.') {
      var parent = this.getParent();
      parent.registerChild(child, name.substr(1));
      return;
    }

    this.registeredChildren.push(child);
  };

  Fieldset.prototype.unregisterChild = function unregisterChild(child, name) {
    if (name && name[0] === '.') {
      var parent = this.getParent();
      parent.unregisterChild(child, name.substr(1));
      return;
    }

    var pos = this.registeredChildren.indexOf(child);
    if (pos !== -1) {
      this.registeredChildren.splice(pos, 1);
    }
  };

  Fieldset.prototype.getChildContext = function getChildContext() {
    return {
      fieldset: this
    };
  };

  Fieldset.prototype.remove = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(index) {
      var parent, value;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof index === 'undefined')) {
                _context.next = 3;
                break;
              }

              parent = this.getParent();
              return _context.abrupt('return', parent.remove(this.getCurrentIndex()));

            case 3:
              value = this.getValue();

              if (!(!Array.isArray(value) || index < 0 || value.length <= index)) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('return', undefined);

            case 6:

              this.setValue([].concat(value.slice(0, index), value.slice(index + 1)));

              return _context.abrupt('return', index);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function remove(_x) {
      return _ref.apply(this, arguments);
    }

    return remove;
  }();

  Fieldset.prototype.up = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(index) {
      var parent, value;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof index === 'undefined')) {
                _context2.next = 3;
                break;
              }

              parent = this.getParent();
              return _context2.abrupt('return', parent.up(this.getCurrentIndex()));

            case 3:
              value = this.getValue();

              if (!(!Array.isArray(value) || index <= 0 || value.length <= index)) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt('return', undefined);

            case 6:

              this.setValue([].concat(value.slice(0, index - 1), [value[index], value[index - 1]], value.slice(index + 1)));

              return _context2.abrupt('return', index);

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function up(_x2) {
      return _ref2.apply(this, arguments);
    }

    return up;
  }();

  Fieldset.prototype.getCurrentIndex = function getCurrentIndex() {
    var name = this.props.name;

    if (name === undefined) {
      throw new Error('This is not an array');
    }

    var indexNumber = Number(name);
    if (indexNumber.toString() !== name.toString() || !isNumber(indexNumber)) {
      throw new Error('Index ' + indexNumber + ' is not a number');
    }

    return indexNumber;
  };

  Fieldset.prototype.down = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(index) {
      var parent, retVar;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(typeof index === 'undefined')) {
                _context3.next = 3;
                break;
              }

              parent = this.getParent();
              return _context3.abrupt('return', parent.down(this.getCurrentIndex()));

            case 3:
              retVar = this.up(index + 1);
              return _context3.abrupt('return', typeof retVar === 'undefined' ? retVar : index);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function down(_x3) {
      return _ref3.apply(this, arguments);
    }

    return down;
  }();

  // return current or parent fieldset


  Fieldset.prototype.resolveByPath = function resolveByPath(path, callback) {
    if (path[0] === '.') {
      var subPath = path.substr(1);
      if (isEmpty(subPath)) {
        return callback(null, this, subPath);
      }

      var parent = this.getParent();
      return parent.resolveByPath(subPath, callback);
    }

    return callback(null, this, path);
  };

  Fieldset.prototype.getChildValue = function getChildValue(path) {
    if (isEmpty(path)) {
      return this.getValue();
    }

    return this.resolveByPath(path, function (err, current, subPath) {
      if (err) {
        throw err;
      }

      var value = current.getValue();
      if (isEmpty(subPath)) {
        return value;
      }

      return get(value, subPath);
    });
  };

  Fieldset.prototype.setChildValue = function setChildValue(path, value, component) {
    this.resolveByPath(path, function (err, current, subPath) {
      if (err) {
        throw err;
      }

      var newValue = value;
      if (!isEmpty(subPath)) {
        var currentValue = current.getValue();

        // current value can be null or undefined
        if (!currentValue) {
          var firstChar = subPath[0];
          var isCharNumber = Number(firstChar).toString() === firstChar;
          currentValue = isCharNumber ? [] : {};
        }

        newValue = set(currentValue, subPath, value);
      }

      current.setValue(newValue, component);

      var onChange = current.props.onChange;

      if (onChange) {
        onChange(newValue, component);
      }
    });
  };

  Fieldset.prototype.buildPath = function buildPath(path) {
    return this.resolveByPath(path, function (err, current, subPath) {
      if (err) {
        throw err;
      }

      var currentPath = current.getPath();
      if (isEmpty(subPath)) {
        return currentPath;
      }

      return currentPath ? currentPath + '.' + subPath : subPath;
    });
  };

  Fieldset.prototype.disableSmartUpdate = function disableSmartUpdate(name) {
    if (!name || name[0] !== '.' || name === '.') {
      return;
    }

    this.smartUpdate = false;

    var parent = this.getParent();
    if (!parent) {
      return;
    }

    parent.disableSmartUpdate(name.substr(1));
  };

  Fieldset.prototype.replaceChildren = function replaceChildren(children) {
    var skipReplace = this.getForm().props.skipReplace;

    if (skipReplace) {
      return children;
    }

    return traverse(children, null, function (child) {
      if (child.props && child.props.skipReplace) {
        return undefined;
      }

      var childChildren = child.props && child.props.children || child.children;

      if (child.type === 'input') {
        return React.createElement(
          Input,
          child.props,
          childChildren
        );
      } else if (child.type === 'select') {
        return React.createElement(
          Select,
          child.props,
          childChildren
        );
      } else if (child.type === 'textarea') {
        return React.createElement(
          Textarea,
          child.props,
          childChildren
        );
      } else if (child.type === 'fieldset' && child.props.name !== undefined) {
        return React.createElement(
          Fieldset,
          child.props,
          childChildren
        );
      } else if (child.type === 'tbody' && child.props.name !== undefined) {
        return React.createElement(
          Fieldset,
          _extends({}, child.props, { tagName: 'tbody' }),
          childChildren
        );
      }

      return undefined;
    });
  };

  Fieldset.prototype.processChildren = function processChildren(children) {
    var value = this.getValue();
    var render = this.props.render;


    if (typeof render === 'function') {
      return this.replaceChildren(render({ value: value }));
    }

    var path = this.getPath();
    var skipMap = this.props.skipMap;

    if (Array.isArray(value) && !skipMap) {
      var childrenOnly = this.props.tagName === 'tbody';

      return value.map(function (item, index) {
        var uniqueKey = path + '.' + index;

        return React.createElement(
          Fieldset,
          {
            name: index,
            key: uniqueKey,
            total: value.length,
            childrenOnly: childrenOnly
          },
          children
        );
      });
    }

    return this.replaceChildren(children);
  };

  Fieldset.prototype.render = function render() {
    var children = this.processChildren(this.props.children);
    var _props = this.props,
        _props$tagName = _props.tagName,
        tagName = _props$tagName === undefined ? 'fieldset' : _props$tagName,
        className = _props.className,
        style = _props.style,
        childrenOnly = _props.childrenOnly;


    if (childrenOnly) {
      return children;
    }

    return createElement(tagName, {
      className: className,
      style: style,
      'data-path': this.getPath()
    }, children);
  };

  return Fieldset;
}(Element);

Fieldset.propTypes = _extends({}, Element.propTypes, (_extends2 = {
  onChange: PropTypes.func,
  index: PropTypes.number,
  total: PropTypes.number,
  children: PropTypes.node,
  tagName: PropTypes.string,
  childrenOnly: PropTypes.bool
}, _extends2['children'] = PropTypes.node, _extends2.sameChildren = PropTypes.bool, _extends2));
Fieldset.childContextTypes = {
  fieldset: PropTypes.object.isRequired
};
Fieldset.contextTypes = {
  fieldset: PropTypes.object
};
export default Fieldset;
//# sourceMappingURL=Fieldset.js.map